import styled from 'styled-components';
import { px } from '../../../utils/px';

const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${px(30)};
  height: 100%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  &:hover {
    background-color: #dedede;
  }
`;

export default ToggleButton;
